export default class Pagination {
    pageSize: number;
    currentPage: number;
    totalSize: number;
    text: string;

    constructor(
        pageSize: number = 10,
        currentPage: number = 1,
        totalSize: number = 0,
        text: string = ''
    ) {
        this.pageSize = pageSize;
        this.currentPage = currentPage;
        this.totalSize = totalSize;
        this.text = text;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/pojo/PaginationObj.ts